import { render, staticRenderFns } from "./applyInformation.vue?vue&type=template&id=55cb6518&scoped=true"
import script from "./applyInformation.vue?vue&type=script&lang=js"
export * from "./applyInformation.vue?vue&type=script&lang=js"
import style0 from "./applyInformation.vue?vue&type=style&index=0&id=55cb6518&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cb6518",
  null
  
)

export default component.exports